<template>
  <footer>
    <v-container class="content-wrapper footer-content" fluid>
      <v-divider class="d-none d-md-block" style="border-width: 1px;"></v-divider>
      <v-row>
        <v-col cols="12" md="4" sm="12" xs="12" class="pr-16">
          <div>
            <img :src="require('@/assets/logo-purple.svg')" />
          </div>
          <div class="mb-2" id="contact-form">
            <v-btn text @click="openContactForm = true" class="pa-0 custom-button">
              Have a question? Contact Us
            </v-btn>
          </div>
          <div class="mt-2" id="social-media">
            <a href="https://www.instagram.com/atrcuae/" target="_blank"
              ><img class="pr-3" :src="require('@/assets/svg/social/instagram.svg')"
            /></a>
            <a href="https://www.youtube.com/channel/UCEu90gz1Yrlpx85FysKVJNw" target="_blank">
              <img class="pr-3 pt-1" :src="require('@/assets/svg/social/youtube.svg')" />
            </a>
            <a href="https://www.linkedin.com/company/atrcuae/?viewAsMember=true" target="_blank">
              <img class="pr-3" :src="require('@/assets/svg/social/linkedin.svg')"
            /></a>
            <a href="https://twitter.com/atrcuae" target="_blank"
              ><img class="pr-3" :src="require('@/assets/svg/social/twitter.svg')"
            /></a>
          </div>
        </v-col>
        <v-divider class="d-none d-md-block" vertical style="border-width: 1px;"></v-divider>
        <v-col cols="12" md="3" sm="12" xs="12" class="pl-md-16">
          <div class="mb-2 text-bold">Contact Information</div>
          <div class="mb-2">Advanced Technology Research Council</div>
          <div class="mb-2">
            P.O.Box: 9639, Yas Arcade, Yas Island, Abu Dhabi, <br />
            United Arab Emirates
          </div>
        </v-col>
        <v-col cols="6" md="2" class="pl-md-16">
          <div class="mb-2 text-bold">
            Resources
          </div>
          <div class="d-flex flex-column">
            <router-link class="mb-2" :to="'/about'">About us</router-link>
            <router-link class="mb-2" :to="'/how-it-works'">How it works</router-link>
            <router-link class="mb-2" :to="'/tutorials'">Tutorials</router-link>
            <router-link class="mb-2" :to="hostingInstitutionsCatalogue"
              >Hosting Institutions</router-link
            >
            <router-link class="mb-2" :to="providerCatalogue">Providers</router-link>
          </div>
        </v-col>
        <v-col cols="6" md="2">
          <div class="mb-2 text-bold">
            Catalogue
          </div>
          <div class="d-flex flex-column">
            <router-link class="mb-2" :to="servicesCatalogue">Services</router-link>
            <router-link class="mb-2" :to="equipmentCatalogue">Equipment</router-link>
            <router-link class="mb-2" :to="patentsCatalogue">Intellectual Property</router-link>
            <router-link class="mb-2" :to="'/Help'">Help</router-link>
          </div>
        </v-col>
        <v-col cols="12" class="d-md-none">
          <span class="footer-credit">
            Powered By
            <a href="https://www.atrc.ae/" target="_blank" class="text-bold">ATRC</a>
          </span>
        </v-col>
        <v-col cols="12" class="d-md-none">
          <span class="footer-credit">
            Developed By
            <a href="https://www.jnp.gr" target="_blank" class="text-bold">JNP</a>
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="12" xs="12" class="pr-16"></v-col>
        <v-divider class="d-none d-md-block" vertical style="border-width: 1px;"></v-divider>
        <v-col cols="12" md="3" sm="12" xs="12" class="pl-md-16"></v-col>
        <v-col cols="6" md="2" class="pl-md-16">
          <div class="d-none d-md-block">
            <span class="footer-credit">
              Powered By
              <a href="https://www.atrc.ae/" target="_blank" class="text-bold">ATRC</a>
            </span>
          </div>
        </v-col>
        <v-col cols="6" md="2">
          <div class="d-none d-md-block">
            <span class="footer-credit">
              Developed By
              <a href="https://www.jnp.gr" target="_blank" class="text-bold">JNP</a>
            </span>
          </div>
        </v-col>
      </v-row>
      <v-divider class="d-none d-md-block" style="border-width: 1px"></v-divider>
      <v-row align="center">
        <v-col cols="12" md="6" class="footer-credit">
          ResearchHub © {{ new Date().getFullYear() }}
        </v-col>
        <v-col cols="12" md="6" class="pa-0 pa-md-3">
          <div class="footer-policy-links d-flex justify-center">
            <PrivacyPolicyModal />
            <CookiesPolicyModal />
            <TermsAndConditionsModal />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog persistent v-model="openContactForm" max-width="800">
      <v-card class="secondaryBackground">
        <v-card-title class="pb-3">
          <v-row>
            <v-col sm="12" class="justify-center d-flex">
              <img
                alt="Logo"
                width="180"
                class="rounded-0 text-center"
                :src="require('@/assets/svg/logo.svg')"
              />
            </v-col>
          </v-row>
          <v-btn icon @click="closeContactForm()" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="py-2"></v-divider>
        <v-card-text>
          <v-form ref="form" :lazy-validation="false" v-model="valid">
            <v-row class="justify-center">
              <v-col cols="12">
                Contact Form:
              </v-col>
              <v-col cols="12">
                <label class="text-bold subtitle-2">Full Name</label>
                <v-text-field
                  class="pt-2"
                  v-model="contactForm.name"
                  :placeholder="'Full Name'"
                  outlined
                  required
                  :rules="requiredRule()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="text-bold subtitle-2">{{ $t('email') }}</label>
                <v-text-field
                  class="pt-2"
                  v-model="contactForm.email"
                  :placeholder="$t('email')"
                  outlined
                  required
                  :rules="emailRules()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="text-bold subtitle-2">Subject</label>
                <v-text-field
                  v-model="contactForm.summary"
                  outlined
                  class="required"
                  data-cy="summary"
                  :rules="minMaxLengthRule(1, 150)"
                  :placeholder="'Your subject here'"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="text-bold subtitle-2">Your message</label>
                <v-textarea
                  v-model="contactForm.description"
                  outlined
                  class="required"
                  data-cy="description"
                  :rules="minMaxLengthRule(1, 1500)"
                  :placeholder="'Your message here'"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <Recaptcha @validate="response => (contactForm.recaptcha = response)" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-spacer></v-spacer>
            <v-col col="4" class="d-flex align-center">
              <v-btn
                large
                class="rounded-lg white--text change-button"
                color="neutral"
                block
                :disabled="!valid || !contactForm.recaptcha"
                @click="onsubmitContactForm()"
                >{{ $t('submit') }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </footer>
</template>

<script>
import util from '@/mixins/util';
import EventBus from '@/helpers/event-bus';
import PrivacyPolicyModal from '@/components/landing-page/policies/PrivacyPolicyModal.vue';
import CookiesPolicyModal from '@/components/landing-page/policies/CookiesPolicyModal.vue';
import TermsAndConditionsModal from '@/components/landing-page/policies/TermsAndConditionsModal.vue';
import Recaptcha from '@/components/Recaptcha';

export default {
  name: 'FooterLandingNew',
  mixins: [util],
  components: { PrivacyPolicyModal, CookiesPolicyModal, TermsAndConditionsModal, Recaptcha },
  data() {
    return {
      openContactForm: false,
      contactForm: {
        name: null,
        summary: null,
        description: null,
        recaptcha: null,
        email: null,
      },
      valid: false,
    };
  },
  mounted() {
    if (window.location.hash === '#contact-form') {
      this.openContactForm = true;
    }
  },
  computed: {
    providerCatalogue() {
      const roles = this.$store.getters.roles;
      const marketplaceProvidersViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Providers';

      let routePath = '';
      if (roles != null) {
        routePath = '/marketplace/providers';
      } else {
        routePath = '/public-catalogue-marketplace/providers';
      }

      return {
        path: routePath,
        query: { selectedCatalogue, marketplaceProvidersViewAll },
      };
    },
    servicesCatalogue() {
      const roles = this.$store.getters.roles;
      const marketplaceServicesViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Services';

      let routePath = '';
      if (roles != null) {
        routePath = '/marketplace/services';
      } else {
        routePath = '/public-catalogue-marketplace/services';
      }

      return {
        path: routePath,
        query: { selectedCatalogue, marketplaceServicesViewAll },
      };
    },
    equipmentCatalogue() {
      const roles = this.$store.getters.roles;
      const marketplaceEquipmentViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Equipment';

      let routePath = '';
      if (roles != null) {
        routePath = '/marketplace/equipment';
      } else {
        routePath = '/public-catalogue-marketplace/equipment';
      }

      return {
        path: routePath,
        query: { selectedCatalogue, marketplaceEquipmentViewAll },
      };
    },
    patentsCatalogue() {
      const roles = this.$store.getters.roles;
      const marketplacePatentsViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Patents';

      let routePath = '';
      if (roles != null) {
        routePath = '/marketplace/patents';
      } else {
        routePath = '/public-catalogue-marketplace/patents';
      }

      return {
        path: routePath,
        query: { selectedCatalogue, marketplacePatentsViewAll },
      };
    },
    hostingInstitutionsCatalogue() {
      const roles = this.$store.getters.roles;
      const selectedCatalogue = 'Browse the Catalogue of Hosting Institutions';

      let routePath = '';
      if (roles != null) {
        routePath = '/marketplace/hosting-institutions';
      } else {
        routePath = '/public-catalogue-marketplace/hosting-institutions';
      }

      return {
        path: routePath,
        query: { selectedCatalogue },
      };
    },
  },
  methods: {
    closeContactForm() {
      this.openContactForm = false;

      if (window.location.hash === '#contact-form') {
        history.replaceState(null, null, window.location.pathname);
      }
    },
    onsubmitContactForm() {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/email/send-contact-form-request', this.contactForm)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('feedback-successfully'),
          });
          this.openContactForm = false;
          for (let member in this.contactForm) {
            this.contactForm[member] = null;
          }
          this.$refs.form.reset();
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);

          if (window.location.hash === '#contact-form') {
            history.replaceState(null, null, window.location.pathname);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped src="../../../styles/footer-landing-new.scss"></style>
